var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource-passwords"},[_c('div',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.$t('newProject.resources.password')))]),_vm._l((_vm.items),function(item){return _c('resource-password-row',{key:item.id,attrs:{"password":item.password}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }